<template>
    <div id="itemDescription">

        <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                <div class="itemMain">
                    <div class="itemSubTitle">{{$t('i_Description')}}</div>
                    <div class="itemContain">
                        <s-input class="Text" id = "description1" name="description1" type="text" maxlength="60" :placeholder="$t('i_Description')" v-model="_Descr1" :state="isValid(_Descr1)"></s-input>
                        <s-input class="Text" id = "description2" name="description2" type="text" maxlength="60" :placeholder="$t('i_Description2')" v-model="_Descr2"></s-input>
                        <s-input class="Text" id = "note" name="note" type="text" maxlength="60" :placeholder="$t('i_Note')" v-model="_Note1"></s-input>
                        <s-input class="Text" id = "note2" name="note2" type="text" maxlength="60" :placeholder="$t('i_Note2')" v-model="_Note2"></s-input>
                    </div>
                </div>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemDescription',
    components: {
        
    },
    props: ['description1', 'description2', 'note1', 'note2', 'leftSize'],
    data() {
        return {
            collaps: false,
        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
    },
    computed: {
        ...mapGetters(['getTheme']),
        _Descr1: {
            get: function() {return this.description1},
            set: function(modifiedValue){this.$emit('update:description1', modifiedValue)}
        },
        _Descr2: {
            get: function() {return this.description2},
            set: function(modifiedValue){this.$emit('update:description2', modifiedValue)}
        },
        _Note1: {
            get: function() {return this.note1},
            set: function(modifiedValue){this.$emit('update:note1', modifiedValue)}
        },
        _Note2: {
            get: function() {return this.note2},
            set: function(modifiedValue){this.$emit('update:note2', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>

</style>